export const getServiceName = <T extends object>(obj: T | undefined): string =>
  typeof obj === 'object' && obj !== null
    && ['isTop3', 'isPremium', 'isPaid'].find((service) => !!obj[service as keyof T])
    || '';
